module.exports = __webpack_public_path__ + "img/MID Logo_On Wht.581681a4.png";